/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */


import Store from "./store";
import par from "par";

export default AdminGroupCountStore;

function AdminGroupCountStore(api) {
	var store = new Store();
	store.raw_get = store.get;
	store.get = get;

	var tracking = [];

	return store;

	function get(id){
		var data = store.raw_get(id);
		if(data) return data;

		if(!isTracking(id))
			track(id);

		return {
			patients: "-",
			inactive: "-",
			active: "-",
			staff: "-",
			users: "-"
		};
	}

	function isTracking(id){
		return tracking.indexOf(id) !== -1;
	}

	function track(id){
		var prefix = api.admin.stats.group;
		return Promise.all([
			prefix.patientCount(id),
			prefix.inactiveCount(id),
			prefix.activeCount(id),
			prefix.staffCount(id),
			prefix.userCount(id)
		]).then(par(handle_count, id));
	}

	function handle_count(id, results){
		store.set(id, {
			patients: results[0],
			inactive: results[1],
			active: results[2],
			staff: results[3],
			users: results[4]
		});
	}
}
